import init from '../../common/base/init';

// Paywall interaction

init(() => {
  const paywall = document.querySelector('.paywall');
  if(!paywall) return;

  const closeButton = document.querySelector('.paywall .-close');

  closeButton.addEventListener('click', (e) => {
    e.preventDefault();
    paywall.style.transform = "translate(0px,0px)";
    paywall.classList.remove('paywall--fixed');
  });

  const footerElement = document.querySelector('.footer');
  let pageHeight,
      footerHeight,
      currentScroll,
      footerScrollHeight = 0;

  const setPaywallSizes = () => {
    pageHeight = document.documentElement.scrollHeight;
    footerHeight = footerElement.clientHeight;
    currentScroll = window.pageYOffset;
    footerScrollHeight = pageHeight - footerHeight;

    repositionPaywall();
  }

  const repositionPaywall = () => {
    currentScroll = window.pageYOffset + window.innerHeight;
    footerScrollHeight = pageHeight - footerHeight;

    const fixedPaywall = document.querySelector('.paywall--fixed');
    if(!fixedPaywall) return;

    if(currentScroll > footerScrollHeight) {
      fixedPaywall.style.transform = "translate(0px,-" + (currentScroll - footerScrollHeight) + "px)";
    } else {
      fixedPaywall.style.transform = "translate(0px,0px)";
    }
  }

  setPaywallSizes();

  window.addEventListener('scroll', () => {
    repositionPaywall();
  });

  window.addEventListener('resize', () => {
    setPaywallSizes();
  });
});
